import { useState } from 'react';

import SvgIcon from '../../../../SvgIcon/SvgIcon';

import QuotationPriceCheckListView from './QuotationPriceCheckListView';
import QuotationPriceCheckCardView from './QuotationPriceCheckCardView';
import QuotationPriceCheckSearch from './QuotationPriceCheckSearch';
import QuotationPriceCheckViewToggle from './QuotationPriceCheckViewToggle';

const QuotationPriceCheckPanel = () => {
  // =====================================================
  // 🔹 State
  // =====================================================

  const [viewMode, setViewMode] = useState<'list' | 'cards'>('list');

  // =====================================================
  // 🎨 Render
  // =====================================================

  return (
    <div className="flex flex-col gap-5">
      {/* ===================================================== */}
      {/* 🔹 Header */}
      {/* ===================================================== */}

      <div
        className="
        flex
        flex-col
        gap-4

        sm:flex-row
        sm:items-center
        sm:justify-between
      "
      >
        {/* Left */}

        <div
          className="
          flex
          min-w-0
          items-start
          gap-3

          sm:items-center
        "
        >
          <div
            className="
            flex
            h-11
            w-11

            shrink-0

            items-center
            justify-center

            rounded-xl

            border
            border-primary/15

            bg-primary/10

            text-primary
          "
          >
            <SvgIcon name="box" />
          </div>

          <div className="min-w-0">
            <h3
              className="
              text-base
              font-semibold

              text-black

              dark:text-white
            "
            >
              Consulta de Precios
            </h3>

            <p
              className="
              mt-1

              text-sm

              text-body
            "
            >
              Consulta rápidamente precios y existencias.
            </p>
          </div>
        </div>

        {/* Badge */}

        <div
          className="
          bg-gray-1

          inline-flex
          h-10

          min-w-[48px]
          items-center

          justify-center

          rounded-xl
          border

          border-stroke

          px-3

          text-sm
          font-semibold

          text-black

          transition-colors
          duration-200

          dark:border-strokedark
          dark:bg-meta-4
          dark:text-white
        "
        >
          Consulta
        </div>
      </div>

      {/* ===================================================== */}
      {/* 🔹 Toolbar */}
      {/* ===================================================== */}

      <div
        className="
        flex
        items-center
        gap-3
      "
      >
        <div className="flex-1">
          <QuotationPriceCheckSearch />
        </div>

        <QuotationPriceCheckViewToggle
          viewMode={viewMode}
          onChange={setViewMode}
        />
      </div>

      {/* ===================================================== */}
      {/* 🔹 Products */}
      {/* ===================================================== */}

      {viewMode === 'list' ? (
        <QuotationPriceCheckListView />
      ) : (
        <QuotationPriceCheckCardView />
      )}
    </div>
  );
};

export default QuotationPriceCheckPanel;
